// import Homepage from './component/Homepage';
import Routing from "./Routing/Routingfile";
import { ToastContainer, toast } from "react-toastify";

function App() {
  return (
    //  <Homepage />
    <>
      
    <Routing />
    </>
     
  );
}

export default App;
